// @ts-nocheck
import { PropsWithChildren, useState } from 'react';
import '@material/web/checkbox/checkbox.js';
import { Typography } from '../typography/typography';
import styled from '@emotion/styled';
import { formatBlanks } from '@taleemabad/db';
import { MarkdownWrapper } from '@taleemabad/dsm/components';

const StyledLabel = styled.label<{ direction: 'ltr' | 'rtl' }>`
  display: flex;
  align-items: center;
  flex-direction: ${({ direction }) =>
    direction === 'rtl' ? 'row-reverse' : 'row'};
  line-break: auto;

  md-checkbox {
    flex-shrink: 0;

    &::part(focus-ring) {
      display: none;
    }
  }
`;
const StyledTypography = styled(Typography)<{ direction: 'ltr' | 'rtl' }>`
  direction: ${({ direction }) => direction};
`;

export interface CheckboxProps extends PropsWithChildren {
  disabled?: boolean;
  defaultChecked?: boolean;
  indeterminate?: boolean;
  stateLess?: boolean;
  label?: string | ReactNode;
  direction?: 'ltr' | 'rtl';
  checked?: boolean;
  className?: string;
  onChange: (isChecked: boolean) => void;
}

export const Checkbox = ({
  disabled = false,
  defaultChecked = false,
  indeterminate = false,
  label = '',
  onChange,
  direction = 'ltr',
  stateLess = false,
  checked = false,
  className,
  ...otherProps
}: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState(() => defaultChecked);
  const props = {};
  if (checked) {
    props.checked = true;
  }
  if (disabled) {
    props.disabled = true;
  }
  if (stateLess) {
    if (defaultChecked) {
      props.checked = defaultChecked;
    }
  } else {
    if (isChecked) {
      props.checked = isChecked;
    }
  }
  if (indeterminate) {
    props.indeterminate = true;
  }

  const onChangeHandler = () => {
    if (stateLess) {
      onChange(!defaultChecked);
    } else {
      setIsChecked(!isChecked);
      onChange(!isChecked);
    }
  };

  return (
    <StyledLabel direction={direction}>
      <md-checkbox
        touch-target="wrapper"
        {...props}
        {...otherProps}
        onClick={onChangeHandler}
      ></md-checkbox>
      {label && typeof label === 'string' ? (
        <StyledTypography
          variant="textTitleSmall"
          direction={direction}
          className={className}
        >
          <MarkdownWrapper
            text={formatBlanks(label)}
            variant="textTitleSmall"
          />
        </StyledTypography>
      ) : (
        label
      )}
    </StyledLabel>
  );
};
